import {FastRobotErrorcode, SetTrayModalType, TrayType, ViewMode} from 'constants/dataEnum';
import {changeView, hideLoading, showLoading} from 'stores/actions/appStateAction';
import {showModalSetTrayID} from 'stores/actions/modalSetTrayIDStateAction';
import {setErrorCodeNumber} from 'stores/business/commonBusiness';
import {showModalInvalidDeck} from 'stores/business/modalStateBusinessAction';
import {checkIsInstrumentIdleAndShowModal} from 'stores/business/setupWizardBusiness/setupWizardInstrumentBusiness';
import {checkTrayReadiness} from 'stores/business/trayCheckingBusiness';
import {getTrayCalibrationTrayType} from 'stores/selectors/trayCalibrationSelectors';
import {InstrumentProcessType} from 'constants/instrumentStatusEnum';
import {showModalUnsupportedTray} from './commonModalBusiness';
import {ejectTray} from './instrumentBusiness';
import {processPendingSave} from './protocolManagementBusiness';
import {checkOngoingCalibration} from './trayCalibrationBusiness';
import {checkAndHandleIsAllowedToStartProcess, setInstrumentProcess} from './instrumentStatusBusiness';
import {showTrayUncalibratedModal} from './trayModalBusiness';

export const callWhenIdleAndTrayReady = (callback) => async (dispatch) => {
  const isIdle = await dispatch(checkIsInstrumentIdleAndShowModal());
  const {isTrayReady, errorCode: trayErrorCode} = await dispatch(checkTrayReadiness());

  if (!isIdle) return;

  if (!isTrayReady) {
    dispatch(onEnterCalibrationMenuErrorHandler(trayErrorCode));
    return;
  }

  callback();
};

export const openTipsPickupCalibrationMenu = () => async (dispatch) => {
  const isIdle = await dispatch(checkIsInstrumentIdleAndShowModal());
  const {isTrayReady, errorCode: trayErrorCode} = await dispatch(checkTrayReadiness());

  if (!isIdle) return;

  if (!isTrayReady) {
    dispatch(onEnterCalibrationMenuErrorHandler(trayErrorCode));
    return;
  }

  dispatch(changeView(ViewMode.TIPS_PICKUP_CALIBRATION));
};

export function openTrayCalibrationPage() {
  return async (dispatch) => {
    const {isExecutor, isIdle: isAutoCalibrationIdle} = await dispatch(checkOngoingCalibration(false));

    if (isExecutor && !isAutoCalibrationIdle) {
      dispatch(changeView(ViewMode.TRAY_CALIBRATION));
      return;
    }

    dispatch(showLoading());
    const {isTrayReady, errorCode: trayErrorCode} = await dispatch(checkTrayReadiness());
    const isAllowed = await dispatch(
      checkAndHandleIsAllowedToStartProcess(InstrumentProcessType.AUTO_TRAY_CALIBRATION),
    );
    dispatch(hideLoading());

    if (!isAllowed) return;

    if (!isTrayReady && trayErrorCode !== FastRobotErrorcode.TrayUncalibrated) {
      dispatch(onEnterCalibrationMenuErrorHandler(trayErrorCode, SetTrayModalType.TRAY_CALIBRATION));
      return;
    }

    dispatch(showLoading());
    await dispatch(ejectTray());
    dispatch(hideLoading());

    dispatch(setInstrumentProcess(InstrumentProcessType.AUTO_TRAY_CALIBRATION));
    dispatch(changeView(ViewMode.TRAY_CALIBRATION));
  };
}

export function openPlateDefinitionPage() {
  return async (dispatch) => {
    dispatch(showLoading());
    const {isTrayReady, errorCode: trayErrorCode} = await dispatch(checkTrayReadiness());
    const isAllowed = await dispatch(checkAndHandleIsAllowedToStartProcess(InstrumentProcessType.PLATE_DEFINITION));
    dispatch(hideLoading());

    if (!isAllowed) return;

    if (!isTrayReady) {
      dispatch(onEnterCalibrationMenuErrorHandler(trayErrorCode, SetTrayModalType.PLATE_TYPE_EDITOR));
      return;
    }

    dispatch(setInstrumentProcess(InstrumentProcessType.PLATE_DEFINITION));
    dispatch(changeView(ViewMode.PLATE_TYPE_EDITOR));
  };
}

export function openSetupWizardPage() {
  return async (dispatch, getState) => {
    const trayType = getTrayCalibrationTrayType(getState());
    const isIdle = await dispatch(checkIsInstrumentIdleAndShowModal());
    const {isTrayReady, errorCode: trayErrorCode} = await dispatch(checkTrayReadiness());

    const allowedTrayType = [TrayType.NORMAL_CADDY, TrayType.HIGH_VOLUME_CADDY];

    if (!isIdle) return;

    if (!isTrayReady && trayErrorCode !== FastRobotErrorcode.TrayUncalibrated) {
      dispatch(onEnterCalibrationMenuErrorHandler(trayErrorCode));
      return;
    }

    if (!allowedTrayType.includes(trayType)) {
      dispatch(showModalUnsupportedTray(true, ViewMode.SETUP_WIZARD));
      return;
    }

    const goToSetupWizard = () => dispatch(changeView(ViewMode.SETUP_WIZARD));

    dispatch(processPendingSave(null, goToSetupWizard, false, false));
  };
}

export function openAutoReteachPage() {
  return async (dispatch) => {
    const callback = () => dispatch(changeView(ViewMode.RETEACH_PLATE));

    await dispatch(callWhenIdleAndTrayReady(callback));
  };
}

export const onEnterCalibrationMenuErrorHandler = (errorCode, trayModalType) => async (dispatch) => {
  await dispatch(setErrorCodeNumber(errorCode));

  switch (errorCode) {
    case FastRobotErrorcode.MissingTray:
      dispatch(showModalInvalidDeck());
      break;
    case FastRobotErrorcode.NO_TRAY_ID_FOUND:
      dispatch(showModalSetTrayID(trayModalType));
      break;
    case FastRobotErrorcode.TrayUncalibrated: {
      const calibrateTrayCallback = () => {
        dispatch(openTrayCalibrationPage());
      };

      dispatch(showTrayUncalibratedModal(calibrateTrayCallback));
      break;
    }
    default:
  }
};
